import { render, staticRenderFns } from "./TranslationEdit.vue?vue&type=template&id=70c88e4a&"
import script from "./TranslationEdit.vue?vue&type=script&lang=ts&"
export * from "./TranslationEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70c88e4a')) {
      api.createRecord('70c88e4a', component.options)
    } else {
      api.reload('70c88e4a', component.options)
    }
    module.hot.accept("./TranslationEdit.vue?vue&type=template&id=70c88e4a&", function () {
      api.rerender('70c88e4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TranslationEdit.vue"
export default component.exports